import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PageLayout } from '@/components';
import { Button } from '@/components/ui';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  return (
    <PageLayout>
      <section className="pt-32 pb-20">
        <div className="container mx-auto px-6 max-w-2xl text-center">
          <p className="text-8xl font-extrabold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-6">
            {t('notFound.code')}
          </p>
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            {t('notFound.title')}
          </h1>
          <p className="text-lg text-slate-600 mb-10">
            {t('notFound.description')}
          </p>
          <div className="flex items-center justify-center gap-4">
            <Button asChild variant="outline" size="lg">
              <Link to="/">
                <ArrowLeft className="w-4 h-4 mr-2" />
                {t('notFound.goBack')}
              </Link>
            </Button>
            <Button asChild variant="gradient" size="lg">
              <Link to="/">
                <Home className="w-4 h-4 mr-2" />
                {t('notFound.home')}
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default NotFound;
